exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rounded-corner[data-v-055c2449]{border-start-start-radius:20px;border-end-end-radius:20px}.responsive[data-v-055c2449]{max-width:100%;height:auto}", ""]);

// exports
